import React from 'react';
import {
  Form,
  Button,
  Switch,
  Typography,
} from 'antd';
import useProfileStore from '../../../stores/useProfileStore';

const { Text } = Typography;

const NotificationsTab = ({ form, messageApi }) => {
  const {
    loading,
    saveNotificationSettings
  } = useProfileStore();

  const handleSaveNotifications = () => saveNotificationSettings(form, messageApi);

  return (
    <div style={{ padding: '0 40px', minHeight: '100%' }}>
      <div style={{ maxWidth: 600, padding: '32px 0' }}>
        <h3 style={{ fontSize: 18, fontWeight: 600, margin: '0 0 24px 0', color: '#263238' }}>Notification Preferences</h3>
        <Form form={form} layout="vertical">
            {[
              { name: 'desktop_notif', label: 'Desktop Notifications', desc: 'Receive notifications on your desktop.' },
              { name: 'email_notif', label: 'Email Notifications', desc: 'Receive important updates via email.' },
              { name: 'sms_notif', label: 'SMS Notifications', desc: 'Receive text message alerts.' }
            ].map(item => (
              <div key={item.name} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 0', borderBottom: '1px solid #f0f0f0' }}>
                 <div>
                    <Text strong style={{ display: 'block', color: '#263238' }}>{item.label}</Text>
                    <Text type="secondary" style={{ fontSize: 13 }}>{item.desc}</Text>
                 </div>
                 <Form.Item name={item.name} valuePropName="checked" noStyle>
                   <Switch />
                 </Form.Item>
              </div>
            ))}

            <div style={{ marginTop: 24, textAlign: 'right' }}>
              <Button
                 onClick={handleSaveNotifications}
                 loading={loading}
                 type="primary"
                 style={{ backgroundColor: '#4CAF50', borderColor: '#4CAF50' }}
              >
                Save Preferences
              </Button>
            </div>
        </Form>
      </div>
    </div>
  );
};

export default NotificationsTab;
